import { connect } from "react-redux";
import { getConnDeviceStatus } from "redux-store/connection/selectors";
import { calcPropsDeviceStatsSelector } from "redux-store/device-stats/selectors";

import { DeviceStats } from "./device-stats";

function mapStateToProps(state, props) {
  return {
    deviceStats: calcPropsDeviceStatsSelector(state, props),
    deviceStatusOnline: getConnDeviceStatus(state),
  };
}

const ConnectedDeviceStats = connect(mapStateToProps)(DeviceStats);

export { ConnectedDeviceStats };
